import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Postquestion.css";
import axios from "../Axios";
import { Link, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
const Postquestion = () => {
    const [cookies, setCookie, removeCookie] = useCookies(null);
    const uname = cookies.username;
    const [questions, setQuestions] = useState({
        title: "",
        desc: "",
        username: uname,
    });
    const [error, setError] = useState(null);

    const navigate = useNavigate();
    const handlePostQ = async (e) => {
        try {
            e.preventDefault();
            if (!questions.title || !questions.desc) {
                setError("please provide both title and description of your question");
            }
            const { data } = await axios.post("/postq", questions);
            if (data.Status === "Success") {
                navigate("/");
            } else if (data.detail) {
                setError(data.detail);
            } else {
                setError(null);
            }
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <div className="pt-5 mb-4">
            <div className="container">
                <h4 className="text-center mt-5">Steps to write a good question</h4>
                <div className="mb-5 ulcenter">
                    <ul>
                        <li style={{ listStyle: "circle" }}>Summerize your problem in a one-line title.</li>
                        <li style={{ listStyle: "circle" }}>Describe your problem in more detail.</li>
                        <li style={{ listStyle: "circle" }}>Describe what you tried and what you expected to happen.</li>
                        <li style={{ listStyle: "circle" }}>Review your question and post it to this site</li>
                    </ul>
                </div>

                <div style={{ border: "solid 2px transparent", borderRadius: "5px", boxShadow: "3px 3px 4px 4px #EDEADE" }} className="py-5">
                    <form onSubmit={handlePostQ}>
                        <h4 className="text-center pb-3">Ask a public question</h4>
                        <Link to="/">
                            <h6 style={{ color: "#fe8402" }} className="text-center">
                                Go to question page
                            </h6>
                        </Link>

                        <div className="text-center">
                            <input type="text" placeholder="title" style={{ width: "80%" }} name="questionTitle" onChange={(e) => setQuestions({ ...questions, title: e.target.value })}></input>
                        </div>
                        <div className="text-center">
                            <textarea placeholder="Question Description" style={{ width: "80%", height: "150px" }} name="questionDesc" onChange={(e) => setQuestions({ ...questions, desc: e.target.value })}></textarea>
                        </div>
                        <button className="w-25 py-2 postqButton" style={{ marginLeft: "10%", backgroundColor: "#516cf0" }}>
                            Post Your question
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Postquestion;
